<template>
  <div class="introduction u-white u-wrapper-panel u-flex u-column u-between u-pad-lg">
    <div class="introduction__bg u-wrapper-panel u-bg-main-color"></div>
    <div class="u-full-width u-center u-relative">
      <img class="u-inline-block u-w1of12 u-w2of12--md u-w4of12--sm" src="/images/logo--transparent.svg">
    </div>
    <div class="u-full-width u-relative">
      <div class="u-center">
        <div class="u-inline-block u-w6of12 u-w10of12--sm t-h1">
          {{ data.title }}
        </div>
      </div>
      <div class="u-center u-marg-t-md">
        <div class="u-inline-block u-w6of12 u-w10of12--sm t-text">
          {{ data.subtitle }}
        </div>
      </div>
    </div>
    <div class="u-full-width u-center">
      <app-button @click="onStart" :to="{name: 'Homepage'}">
        {{ data.CTALabel }}
      </app-button>
    </div>
  </div>
</template>

<script>
import Page from './Page'

import { Vector3 } from 'three'

import { authorizeAccelerometer } from 'shimmer'

export default {
  mixins: [Page],

  computed: {
    data () {
      return this.$store.getters['pages/homepage']
    },
    _position () {
      if (this.data.position.length) {
        return new Vector3(parseFloat(this.data.position[0].x), parseFloat(this.data.position[0].y), parseFloat(this.data.position[0].z))
      }
    },
    _look () {
      if (this.data.position.length) {
        return new Vector3(parseFloat(this.data.look[0].x), parseFloat(this.data.look[0].y), parseFloat(this.data.look[0].z))
      }
    }
  },

  methods: {
    onStart () {
      this.$hub.emit('audio:background')
      this.$ga.send('navigation', 'introduction', 'next')
      if (this.$device.isMobile) {
        authorizeAccelerometer()
      }
    }
  }
}  
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.introduction
  &__bg
    opacity .8
</style>